<template>
  <el-button size="mini" type="primary" @click="onExport">导出Excel</el-button>
</template>

<script>
import host from 'Host';

export default {
  name: "glueExportExcel",
  props: {
    action: '',
    params: {
      type: Object,
      default: () => {
      }
    }
  },
  methods: {
    onExport() {
      this.$api.get_glue(this.action, this.params, (res) => {
        if (res.data) {
          window.location.href = host.glue + res.data;
        }
      }, (res) => {
        this.$message.warning(res.msg);
      });
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// glueExportExcel.vue?4591274c